import { __assign } from "tslib";
/* eslint-disable no-shadow */
import * as PropTypes from 'prop-types';
import { mq, breakpoints } from '../mediaQuery';
import { getKeys } from '../getKeys';
export function isReponsiveObject(prop) {
    return (Object.prototype.hasOwnProperty.call(prop, 'xs') ||
        Object.prototype.hasOwnProperty.call(prop, 's') ||
        Object.prototype.hasOwnProperty.call(prop, 'm') ||
        Object.prototype.hasOwnProperty.call(prop, 'l') ||
        Object.prototype.hasOwnProperty.call(prop, 'xl') ||
        Object.prototype.hasOwnProperty.call(prop, 'xxl'));
}
function normalizeReponsiveProp(prop, defaultValue) {
    // @ts-ignore
    if (typeof prop === 'object' && isReponsiveObject(prop)) {
        return __assign({ xs: defaultValue }, prop);
    }
    return {
        xs: prop !== undefined ? prop : defaultValue,
    };
}
function sortBreakpoints(obj) {
    return getKeys(obj).sort(function (a, b) { return breakpoints[a] - breakpoints[b]; });
}
function wrapInMq(breakpoint, style) {
    if (!style)
        return undefined;
    if (breakpoint === 'xs')
        return style;
    return "".concat(mq(breakpoint), " { ").concat(style, " }");
}
function getNextSmallerBreakpoint(bp, prop, bpList, index) {
    if (bpList === void 0) { bpList = getKeys(breakpoints); }
    if (index === void 0) { index = bpList.findIndex(function (b) { return b === bp; }); }
    return Object.prototype.hasOwnProperty.call(prop, bp)
        ? prop[bp] // eslint-disable-line @typescript-eslint/no-non-null-assertion
        : getNextSmallerBreakpoint(bpList[index - 1], prop, bpList, index - 1);
}
function arrayify(prop, defaultValue) {
    var propArray = Array.isArray(prop) ? prop : [prop];
    var defaultArray = Array.isArray(defaultValue)
        ? defaultValue
        : [defaultValue];
    return propArray.map(function (property, index) {
        return normalizeReponsiveProp(property, defaultArray[index]);
    });
}
export function responsiveProp(prop, defaultValue, callback) {
    var normalized = arrayify(prop, defaultValue);
    var allBreakpoints = normalized.reduce(function (acc, dep) { return (__assign(__assign({}, acc), dep)); }, {});
    return sortBreakpoints(allBreakpoints)
        .map(function (bp) {
        return wrapInMq(bp, callback.apply(void 0, normalized.map(function (p) { return getNextSmallerBreakpoint(bp, p); })));
    })
        .filter(Boolean)
        .join(' ');
}
/**
 * Creates a PropType allowing either a value or a responsive prop object of
 * the shape { xs?: T, s?: T, m?: T, l?: T, xl?: T, xxl?: T, }
 * @param {PropType} propType PropType for the prop e.g. PropType.string or PropType.bool
 * @returns {PropType} PropType for a responsive prop
 */
export function responsivePropTypes(propType) {
    return PropTypes.oneOfType([
        propType,
        PropTypes.shape({
            xs: propType,
            s: propType,
            m: propType,
            l: propType,
            xl: propType,
            xxl: propType,
        }),
    ]);
}
//# sourceMappingURL=responsiveProp.js.map